import React from 'react';
import { FormikInput } from '../../web.common';
import { connect } from 'formik';
import { makeDebouncer } from '../../common/makeDebouncer';

class SearchInternal extends React.Component {
  constructor() {
    super();
    this.debouncer = makeDebouncer(500);
  }

  render() {
    const { props } = this;
    const { searchFunction, onChange, formik } = props;
    const { setFieldValue } = formik;

    return (
      <>
        {
           props.clear ? <div 
           style={{ cursor: 'pointer' }}
           onClick={() => {
             console.log('boh');
             setFieldValue(props.name, '');
           }}
           >Clear</div> : ''
        }
        <FormikInput
          {...props}
          type='select-async'
          loadOptions={async key => {
            const result = await this.debouncer(key, keyDebouncer => searchFunction(keyDebouncer));
            return result.map(x => ({
              label: x.Name,
              value: x.Id
            }));
          }}
          onChange={onChange ? newValue => onChange({ setFieldValue, newValue }) : null}
          placeholder
          required
        />
      </>
    );
  }
}

export const Search = connect(SearchInternal);